import { FeatureFlags } from '../types';

export const FEATURE_FLAGS_KEY = 'feature-flags';

// TODO: REMOVE FEATURE FLAG LOGIC. Replace below line with an endpoint call to get feature flags
export const FEATURE_FLAGS: FeatureFlags[] = import.meta.env.VITE_FEATURE_FLAGS.split(',') as FeatureFlags[];

export const FEATURE_FLAGS_ON: boolean = import.meta.env.VITE_FEATURE_FLAGS_ON === 'true';
